// extracted by mini-css-extract-plugin
export default {"heatmapContainer":"styles_heatmapContainer__-4W4M","heatmapBgImage":"styles_heatmapBgImage__rBQ2h"};